export enum Role {
  USER = <any>'USER',
  TEACHER = <any>'TEACHER',
  AGENT = <any>'AGENT',
  INSTITUTION = <any>'INSTITUTION',
  CREATOR = <any>'CREATOR',
  MODERATOR = <any>'MODERATOR',
  ADMIN = <any>'ADMIN'
}
